<template>
  <div class="dialog-form">
    <el-drawer v-if="type === 'drawer'"
               :title="dialogTitle"
               :before-close="handleClose"
               :visible.sync="dialogVisible"
               :size="drawerSize"
               custom-class="demo-drawer"
               ref="drawer"
    >
      <div class="demo-drawer__content">
        <el-form :model="data" :rules="ruleList" ref="form" :disabled="formDisable" @submit.native.prevent>
          <div v-if="approvalMark === 2" class="approval-mark success">通过审核</div>
          <div v-else-if="approvalMark === 3" class="approval-mark fail">未通过审核</div>
          <div v-for="(item, index) in fileList" v-bind:key="index">
            <!-- head -->
            <p v-if="item.head && item.show !== false" class="dialog-form_head">{{item.head}}</p>
            <el-form-item v-if="item.show !== false"
                          :label="item.label" :label-width="item.labelWidth ? item.labelWidth : labelWidth" :prop="item.prop">
              <!-- input/password/num -->
              <el-input v-if="item.type === 'input'"
                        v-model="data[item.prop]"
                        :type="item.type"
                        :placeholder="item.placeholder || '请输入'"
                        :disabled="item.disabled"></el-input>
              <!-- textarea -->
              <el-input v-if="item.type === 'textarea'"
                        v-model="data[item.prop]"
                        :type="item.type"
                        :placeholder="item.placeholder || '请输入'"
                        :disabled="item.disabled"
                        :maxlength="item.max"
                        :rows="10"
                        show-word-limit></el-input>
              <!-- password -->
              <el-input v-if=" item.type === 'password'"
                        v-model="data[item.prop]"
                        :type="item.type"
                        :placeholder="item.placeholder || '请输入'"
                        :disabled="item.disabled"
                        :show-password="isShowPwd"
                        @change="changePwd"
                        autocomplete="off"></el-input>
              <!-- switch -->
              <el-switch v-if="item.type === 'switch'"
                         :disabled="item.disabled"
                         v-model="data[item.prop]" :active-value="1" :inactive-value="0"></el-switch>
              <!-- text -->
              <span v-if="item.type === 'text'">
                {{data[item.prop] ? data[item.prop] : '-'}}
              </span>
              <!-- select -->
              <el-select :disabled="item.disabled" v-if="item.type === 'select'" :multiple="item.multiple" placeholder="请选择" v-model="data[item.prop]">
                <el-option v-for="(option, index) in item.options" v-bind:key="index"
                           :value="option.val || option.id || option.value" :label="option.name || option.label"></el-option>
              </el-select>
              <!-- datePicker -->
              <el-date-picker
                :disabled="item.disabled"
                v-if="item.type === 'datePicker'"
                v-model="data[item.prop]"
                :type="item.pickerType ? item.pickerType : 'date'"
                :value-format="item.pickerType === 'year' ? 'yyyy' : 'yyyy-MM-dd'"
                placeholder="选择日期">
              </el-date-picker>
              <!-- cascader -->
              <el-cascader
                :disabled="item.disabled"
                v-if="item.type === 'cascader'"
                v-model="data[item.prop]"
                :options="item.options"
                :props="item.props"
                @change="handleChange">
              </el-cascader>
              <!-- uploadPicture -->
              <el-row v-if="item.type === 'uploadPicture'" type="flex" justify="start" align="middle">
                <el-col>
                  <el-upload
                    class="avatar-uploader"
                    :action="$global.httpBaseURL + $global.uploadPath"
                    :data="uploadData"
                    :show-file-list="false"
                    :on-success="(res, file) => handleAvatarSuccess(res, file, item.prop, item)"
                    :before-upload="beforeAvatarUpload">
                    <img v-if="data[item.prop] && data[item.prop].attachUrl" :src="data[item.prop].attachUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
                </el-col>
                <el-col>
                  <span class="upload-picture_tip">图片尺寸{{item.width}} X {{item.height}},不能大于1M</span>
                </el-col>
              </el-row>
              <!-- slot -->
              <template v-if="item.type === 'slot'">
                <slot :name="'form-' + item.prop" />
              </template>
            </el-form-item>
          </div>
        </el-form>
        <div class="demo-drawer__footer" v-if="!formDisable
        && !(approvalMark === 2 || approvalMark === 3)">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" v-if="!(this.dialogTitle === '请假条' && flowStage === -1)" @click="submit">确 定</el-button>
        </div>
      </div>
    </el-drawer>
    <el-dialog v-else :title="dialogTitle" :visible.sync="dialogVisible"
               :width="width" :before-close="handleClose" :append-to-body="appendToBody">
      <el-form :model="data" :rules="ruleList" ref="form" :disabled="formDisable" @submit.native.prevent>
        <div v-for="(item, index) in fileList" v-bind:key="index">
          <!-- head -->
          <p v-if="item.head && item.show !== false" class="dialog-form_head">{{item.head}}</p>
          <el-form-item  v-if="item.show !== false"
                         :label="item.label" :label-width="item.labelWidth ? item.labelWidth : labelWidth" :prop="item.prop">
            <!-- input/number -->
            <el-input v-if="item.type === 'input' || item.type === 'number'"
                      v-model="data[item.prop]"
                      :type="item.type"
                      :placeholder="item.placeholder || '请输入'"
                      :disabled="item.disabled"></el-input>
            <!-- textarea -->
            <el-input v-if="item.type === 'textarea'"
                      v-model="data[item.prop]"
                      :type="item.type"
                      :placeholder="item.placeholder || '请输入'"
                      :disabled="item.disabled"
                      :maxlength="item.max"
                      :rows="10"
                      show-word-limit></el-input>
            <!-- password -->
            <el-input v-if=" item.type === 'password'"
                      v-model="data[item.prop]"
                      :type="item.type"
                      :placeholder="item.placeholder || '请输入'"
                      :disabled="item.disabled"
                      :show-password="isShowPwd"
                      @change="changePwd"
                      autocomplete="off"></el-input>
            <!-- switch -->
            <el-switch v-if="item.type === 'switch'"
                       v-model="data[item.prop]"
                       :disabled="item.disabled"
                       :active-value="1" :inactive-value="0"></el-switch>
            <!-- text -->
            <span v-if="item.type === 'text'">
              <span v-if="item.textContent">{{item.textContent}}</span>
              <span v-else>{{data[item.prop]}}</span>
            </span>
            <!-- select -->
            <el-select
              :disabled="item.disabled"
              @change="(val) => item.onChange ? item.onChange(val) : null"
              v-if="item.type === 'select'" :multiple="item.multiple" placeholder="请选择" v-model="data[item.prop]">
              <el-option v-for="(option, index) in item.options" v-bind:key="index"
                         :disabled="item.disabledProp ? option[item.disabledProp] === item.disabledValue : false"
                         :value="option.val || option.id || option.value" :label="option.name || option.label"></el-option>
            </el-select>
            <!-- datePicker -->
            <el-date-picker
              v-if="item.type === 'datePicker'"
              v-model="data[item.prop]"
              :disabled="item.disabled"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
            <!--datePickerRange-->
            <el-date-picker
              v-if="item.type === 'datePickerRange'"
              v-model="data[item.prop]"
              :disabled="item.disabled"
              type="daterange"
              range-separator="至"
              value-format="yyyy-MM-dd"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <!--dateTimePickerRange-->
            <el-date-picker
              v-if="item.type === 'dateTimePickerRange'"
              v-model="data[item.prop]"
              :disabled="item.disabled"
              type="datetimerange"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <!-- cascader -->
            <el-cascader
              v-if="item.type === 'cascader'"
              v-model="data[item.prop]"
              :options="item.options"
              :props="item.props"
              @change="handleChange">
            </el-cascader>
            <!-- uploadPicture -->
            <el-row v-if="item.type === 'uploadPicture'" class="upload-piture-box">
              <el-upload
                :disabled="item.disabled"
                class="avatar-uploader"
                :action="$global.httpBaseURL + $global.uploadPath"
                :data="uploadData"
                :show-file-list="false"
                :on-success="(res, file) => handleAvatarSuccess(res, file, item.prop, item)"
                :before-upload="beforeAvatarUpload">
                <img v-if="data[item.prop] && data[item.prop].attachUrl" :src="data[item.prop].attachUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span class="upload-picture_tip">图片尺寸{{item.width}} X {{item.height}},不能大于1M</span>
            </el-row>
            <!-- colorPicker -->
            <el-color-picker v-if="item.type === 'colorPicker'"
                             v-model="data[item.prop]"></el-color-picker>
            <!-- slot -->
            <template v-if="item.type === 'slot'">
              <slot :name="'form-' + item.prop" />
            </template>
            <el-tooltip v-if="item.tip" class="item" effect="dark" placement="right-start">
              <div slot="content">
                <span v-if="typeof item.tip === 'string'">{{item.tip}}</span>
                <div v-else>
                  <p v-for="(item,index) in item.tip" :key="index">{{item}}</p>
                </div>
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>
        </div>
      </el-form>
      <template>
        <slot name="tabs"></slot>
      </template>
      <div slot="footer" class="dialog-footer" v-if="!formDisable && !footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
      <div slot="footer" class="dialog-footer" v-if="!formDisable && footer">
        <slot name="footerBtns"></slot>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { checkPwd } from '../../utils/validate'
export default {
  name: 'pageForm',
  data () {
    return {
      isShowPwd: false,
      uploadData: {
        TOKEN_KEY: localStorage.getItem('token')
      }
    }
  },
  props: {
    // 弹窗类型
    type: {
      type: String
    },
    // 权限名称
    permission: {
      type: String
    },
    // 弹窗名称
    dialogTitle: {
      type: String
    },
    // 弹窗开关
    dialogVisible: {
      type: Boolean
    },
    // 表单数据
    data: {
      type: Object
    },
    // 表单验证规则
    ruleList: {
      type: Object
    },
    // 表单列表
    fileList: {
      type: Array
    },
    // label宽度
    labelWidth: {
      type: String
    },
    // 关闭弹窗
    handleClose: {
      type: Function
    },
    // 提交
    submit: {
      type: Function
    },
    // dialog 宽度
    width: {
      type: String,
      default: '40%'
    },
    // drawer 宽度
    drawerSize: {
      type: String,
      default: '30%'
    },
    appendToBody: {
      type: Boolean
    },
    approvalMark: {
      type: Number
    },
    flowStage: {
      type: Number
    },
    footer: {
      type: Boolean
    }
  }, // 接收父组件的方法
  computed: {
    formDisable () {
      if (this.dialogTitle.indexOf('编辑') !== -1) {
        return this.$has(this.permission + 'Edit')
      } else if (this.dialogTitle.indexOf('新增') !== -1 || this.dialogTitle.indexOf('添加') !== -1 || this.dialogTitle.indexOf('新建') !== -1) {
        return this.$has(this.permission + 'Add')
      } if (this.dialogTitle.indexOf('查看') !== -1) {
        return this.$has(this.permission + 'View')
      } else {
        return true
      }
    }
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        if (this.$refs) {
          setTimeout(() => {
            this.$emit('update:refObj', this.$refs.form)
            this.isShowPwd = false
          }, 50)
        }
      },
      deep: true // 深度监听
    }
  },
  mounted () {
    // 将form实例返回到父级
    if (this.$refs.form) {
      this.$emit('update:refObj', this.$refs.form)
      this.isShowPwd = false
    }
  },
  methods: {
    handleChange (val) {
      // console.log(val, 'handleChange')
    },
    // 密码
    changePwd (val, prop) {
      this.isShowPwd = true
      // this.ruleList.pwd.push({
      //   validator: checkPwd,
      //   trigger: 'blur'
      // })
    },
    /*
    * 图片上传
    * */
    handleAvatarSuccess (res, file, prop, item) {
      if (res.code === 200) {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success'
        })
        this.data[prop] = {
          ...this.data[prop],
          id: '',
          attachUrl: ''
        }
        this.data[prop].id = res.obj
        this.data[prop].attachUrl = URL.createObjectURL(file.raw)
      }
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG或PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 1M')
      }
      return isJPG && isLt2M
    }
  }
}
</script>

<style scoped>
  .avatar-uploader {
    margin-right: 20px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .upload-picture_tip {
    color: #666666;
  }

  .dialog-form_head {
    font-size: 14px;
    background-color: rgba(161, 161, 161, 0.36);
    padding: 6px 0 6px 14px;
    margin-bottom: 14px;
    color: #484848;
  }

   >>> .el-form-item__label {
    padding-left: 26px;
    text-align: left;
  }

  .demo-drawer__content form {
    position: relative;
  }

  .approval-mark {
    position: absolute;
    right: 25%;
    top: 9%;
    z-index: 1;
    width: 170px;
    height: 170px;
    border-radius: 50%;
    border: 1px solid #919191;
    text-align: center;
    line-height: 170px;
    font-weight: bold;
    font-size: 20px;
    transform: rotate(-30deg);
  }

  .approval-mark.fail {
    color: #cf0000;
  }

  .approval-mark.success {
    color: green;
  }

  .upload-piture-box {
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/Form/DialogForm.vue